import _extends from '../../../node_modules/@babel/runtime/helpers/extends.js';
import { forwardRef } from 'react';
import 'prop-types';
import merge from 'deepmerge';
import { GlyphRight } from '@americanexpress/dls-icons';
import ButtonBase from './Base/ButtonBase.js';
import btnChevron from '../../styles/btnChevron.js';
import { dlsGray03 } from '../../styles/colorsDls/dlsGray03.js';
import { dlsGray05 } from '../../styles/colorsDls/dlsGray05.js';
import { jsx } from '@emotion/core';

const ButtonChevron = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    children,
    theme,
    ...otherProps
  } = props;
  const styleTypeObject = merge.all([btnChevron.btnChevron, {
    '&::after': {}
  }, theme]);
  const chevronStyleObject = {
    marginRight: '0.375rem',
    marginTop: '-0.5rem',
    position: 'absolute',
    right: '0',
    top: '50%',
    ...(otherProps.disabled ? dlsGray03 : dlsGray05)
  };
  return jsx(ButtonBase, _extends({}, otherProps, {
    theme: styleTypeObject,
    ref: ref,
    styled: true
  }), children, jsx(GlyphRight, {
    size: "lg",
    theme: chevronStyleObject
  }));
});
ButtonChevron.displayName = 'ButtonChevron';
ButtonChevron.defaultProps = {
  children: '',
  type: 'button',
  theme: {}
};
var ButtonChevron$1 = ButtonChevron;

export { ButtonChevron$1 as default };
